import { makeStyles, withStyles } from '@material-ui/core/styles';
import View from "../../../../assets/img/svg/view.svg"
import Edit from "../../../../assets/img/svg/edit.svg"
import Delete from "../../../../assets/img/svg/delete.svg"
import del from "../../../../assets/img/svg/Del.svg"
import EditAction from "../../../../assets/img/svg/EditAction.svg"
import { useNavigate } from 'react-router-dom';
import { applyDataTable } from '../../../custom/dataTable';
import { ScrollTable } from '../../../custom/ScrollTable';
import Save from "../../../../assets/img/svg/save.svg"
import Cancel from "../../../../assets/img/svg/cancel.svg"
import React, { Component } from "react"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import $ from 'jquery';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { TextField, InputBase, InputAdornment, IconButton, Checkbox } from '@material-ui/core';
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import moment from "moment";
import { CssTextField, CssTextFieldLast } from "../../../custom/textField";

class ListViewTPOY extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            showhide: false,
            DeleteId: 0,
            index: 0,
            HoverId: 0,
            actualHoverId: 0,
            plandate: [],
            putplandate: {
                "PlannedDate": "",
                "ActualDate": "",
                "Id": 0,
                "TrainingId": 0,
                "Month": "",
                "Modify": ""
            },
            UserRole: "",
            NewRow: {
                "Id": 0,
                "ProjectId": 0,
                "TrainingTitle": "",
                "Modify": ""
            },
            Tr_tile: {
                "Id": 0,
                "ProjectId": 0,
                "TrainingTitle": "",
                "Modify": ""
            },
            Training_Month: [],
            render: false,
            Training_View: [],
            selectedDate: '',
            findtrtitle: false,
            Title: {
                Id: 0,
                ProjectId: 0,
                Modify: ""
            }
        }
    }

    componentDidMount() {
        this.state.ProjectId = localStorage.getItem("DashId");
        (localStorage.getItem("UserRoles") == "Admin" || localStorage.getItem("UserRoles") == "Supervisor") ? this.setState({ isView: false }) : this.setState({ isView: true })
        this.state.putplandate.Modify = localStorage.getItem("UserRoles");
        this.state.Title.Modify = localStorage.getItem("UserRoles");
        this.state.NewRow.Modify = localStorage.getItem("UserRoles");
        this.state.Tr_tile.Modify = localStorage.getItem("UserRoles");
        this.state.Title.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.Tr_tile.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.NewRow.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.GetTrining(this.state.ProjectId)
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#PLAN1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Trainingplan1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Trainingplan").addClass("d-none");
        $("#Trainingplan").removeClass("d-block");
        $("#TPL").removeClass("active-color");
        $("#TPT").removeClass("fw-bolder");
    }

    Training_Month = (id) => {
        let apiUrl = API.TRAINING_PLAN + '/projectId?projectId=' + id;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
            // data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.setState({
                        Training_Month: response.data,
                    })
                    let array = [];
                    this.state.Training_View && this.state.Training_View.map((i, ind) => (
                        this.state.Training_Month && this.state.Training_Month.map((m) => (
                            i.ActualDate && i.ActualDate.filter(x => x.Month == m.Month).length > 0 ? "" :
                                array.push({
                                    "PlannedDate": null,
                                    "ActualDate": null,
                                    "Month": m.Month,
                                    "Id": 0,
                                    "TrainingTitle": i.TrainingTitle,
                                    "TrainingId": i.Id,
                                })
                        ))
                    ))
                    if (Object(array).length > 0) {
                        this.Post_Actual1(array)
                    } else {
                        this.state.render = true;
                        this.setState({})
                        this.props.dispatch({ type: "SHOW_LOADER", data: false })
                    }

                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }
    Training_Title = (data) => {
        let apiUrl = API.TRAINING_PLAN;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.postactualprepare(response.data)
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    postactualprepare = (id) => {
        this.state.plandate = [];
        this.setState({})
        this.state.Training_Month.map((i) => {
            let data = {
                "PlannedDate": null,
                "ActualDate": null,
                "Month": i.Month,
                "Id": 0,
                "TrainingId": id,
                "Modify": localStorage.getItem("UserRoles"),
            }
            this.state.plandate.push(data)
        })
        this.setState({})
        this.Post_Actual(this.state.plandate)
    }

    Post_Actual = (data) => {
        let apiUrl = API.TRAINING_PLAN + '/actual'
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.GetTrining(this.state.ProjectId)
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.GetTrining(this.state.ProjectId)
                this.Training_Month(this.state.ProjectId)
                this.props.navigate(`/trainingplanofyard`)
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    GetTrining = (id) => {
        let apiUrl = API.TRAINING_PLAN + "?projectId=" + id
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
            // data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.setState({
                        Training_View: response.data
                    })
                    this.Training_Month(this.state.ProjectId)
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    OpenPopup = (id) => {
        this.state.DeleteId = id;
        this.setState({})
        window.$("#deletepopup").modal("show")
    }

    DeleteItem = () => {
        window.$("#deletepopup").modal("hide")
        this.rowDelete(this.state.DeleteId, this.state.UserRole)
    }

    rowDelete = (id, modify) => {
        let apiUrl = API.TRAINING_PLAN + "/" + id + "?modify=" + modify;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,
            // data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.GetTrining(this.state.ProjectId)
                    this.props.navigate(`/trainingplanofyard`)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    handleClick = (e, Id) => {
        if (e.target.value.trim() == "" && this.state.Training_View[this.state.Training_View.length - 1].Id != Id) {
            this.rowDelete(Id, this.state.UserRole)
        } else {
            this.state.Tr_tile.TrainingTitle = e.target.value.trim();
            this.state.Tr_tile.Id = Id;
            this.setState({})
            this.PutTraining_Details(this.state.Tr_tile, this.state.Tr_tile.Id)
        }
    }

    PutTraining_Details = (data, id) => {
        let apiUrl = API.TRAINING_PLAN + '/id?id=' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.index = 0;
                    this.state.findtrtitle = false;
                    this.setState({})
                    this.GetTrining(this.state.ProjectId)
                } else {
                }
            })
            .catch((error) => {
                this.GetTrining(this.state.ProjectId)
                this.Training_Month(this.state.ProjectId)
                this.props.navigate(`/trainingplanofyard`)
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    AddNew = () => {
        let lastElement = this.state.Training_View.length == 0 ? " " : this.state.Training_View[this.state.Training_View.length - 1].TrainingTitle;
        if (lastElement == '') {
            this.state.findtrtitle = true;
            this.setState({})
        }
        else {
            this.state.Title.ProjectId = parseInt(localStorage.getItem("DashId"));

            this.state.NewRow.ProjectId = parseInt(localStorage.getItem("DashId"));
            this.Training_Title(this.state.NewRow)
        }
    };

    ActualEditPage = (i) => {
        localStorage.setItem("TrainingPlanEditId", i)
        this.props.navigate(`/trainingplanofyard/edit`)
    };

    handleChangeDate = (e, a) => {
        if (e.target.value != "") {
            this.state.putplandate.TrainingId = a.TrainingId;
            this.state.putplandate.Id = a.Id;
            this.state.putplandate.PlannedDate = e.target.value;
            this.state.putplandate.ActualDate = Date.parse(moment(a.PlannedDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")) <= Date.parse(moment(new Date()).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")) ? a.ActualDate : null;
            this.state.putplandate.Month = a.Month;
            this.setState({})
            this.putplanneddate(this.state.putplandate, this.state.putplandate.Id)
        }
        if (e.target.value == "") {
            this.state.putplandate.TrainingId = a.TrainingId;
            this.state.putplandate.Id = a.Id;
            this.state.putplandate.PlannedDate = null;
            this.state.putplandate.ActualDate = a.ActualDate;
            this.state.putplandate.Month = a.Month;
            this.setState({})
            this.putplanneddate(this.state.putplandate, this.state.putplandate.Id)
        }
        this.state.Training_View.map((i, ind) => (
            i.ActualDate.map((s, index) => (
                s.Id == a.Id ? s.PlannedDate = e.target.value : ""
            ))
        ))
        this.setState({})
    }

    Post_Actual1 = (data) => {
        let apiUrl = API.TRAINING_PLAN + '/actual'
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.GetTrining1(this.state.ProjectId)
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    GetTrining1 = (id) => {
        let apiUrl = API.TRAINING_PLAN + "?projectId=" + id
        axios({
            method: "GET",
            url: apiUrl,
            // data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.setState({
                        Training_View: response.data
                    })
                    this.state.render = true;
                    this.setState({})
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    putplanneddate = (data, id) => {
        let apiUrl = API.TRAINING_PLAN + '/' + id;
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    handleInputChange = (e, Id) => {
        if (e.target.value.trim() == "" && this.state.Training_View[this.state.Training_View.length - 1].Id == Id) {
            this.state.findtrtitle = true;
        }
        else {
            this.state.findtrtitle = false;
        }
        this.state.Training_View.map((i) => (
            i.Id == Id ? i.TrainingTitle = e.target.value : ""
        ))
        this.state.index = Id;
        this.setState({})
        document.getElementById("title" + Id).focus()
    };

    handleFocusNameChange = (e, str, val) => {
        this.setState({ index: str.Id })
        if (e.target.value.trim().length > 0) {
            document.getElementById("title" + str.Id).selectionStart = e.target.value.trim().length;
            document.getElementById("title" + str.Id).focus()
        }
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#PLAN1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Trainingplan1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Trainingplan").removeClass("d-none");
        $("#Trainingplan").addClass("d-block");
        $("#TPL").addClass("active-color");
        $("#TPT").addClass("fw-bolder");
    };

    sidebar = () => {
        this.props.navigate("/sidebar");
    };

    render() {
        const { Loop, Training_View } = this.state;
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row border-bottom w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar}>
                                            <ListItemText id={"PLAN" + "1"} className='textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="PLAN" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Training Plan </h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    <div className="row">
                        <div className="px-4 pt-4">
                            <div className="col-12">
                                {this.state.isMobile ? <></> : <h6>Training Plan</h6>}
                            </div>
                            <div className="col-12 pt-3 py-1">
                                <div className={`${window.innerWidth < 1000 ? "" : this.state.isView === false ? "table-container1" : "table-container2"} table-responsive`}>
                                    <table id="tableview" className="table cellborder">
                                        <thead>
                                            <tr className="table-active row-head">
                                                <th rowspan="2" className={`${window.innerWidth < 1000 ? "border-left" : "sl-no"} text-center align-middle`} style={{ minWidth: '3%', maxWidth: '3%', width: '3%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>S.No</span></th>
                                                <th rowspan="2" className={`${window.innerWidth < 1000 ? "" : "tr-title"} text-center align-middle`} style={{ minWidth: '294px', maxWidth: '270px', width: '270px' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Training Title</span></th>
                                                <th className={`${window.innerWidth < 1000 ? "" : "pldate-aldate"} text-center align-middle`} style={{ minWidth: '108px', maxWidth: '108px', width: '108px' }}><span className="spandoc-thead" style={{ color: "#000000" }}>PD/AD</span></th>
                                                {this.state.Training_Month && this.state.Training_Month.map((i, ind) => (
                                                    <th className="text-center align-middle" style={{ width: '77px', minWidth: '77px' }}><span className="spandoc-thead" style={{ color: "#000000" }}>{i.Month && i.Month}</span></th>
                                                ))}
                                                {this.state.isView === false ? <>
                                                    <th className={`${window.innerWidth < 1000 ? "border-right" : "action"} border-right text-center align-middle`} style={{ minWidth: '89px', maxWidth: '8%', width: '8%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                                </> : <></>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.render == true ?
                                                this.state.Training_View && this.state.Training_View.map((i, ind) => (<>
                                                    <tr>
                                                        <td rowspan="2" className={`${window.innerWidth < 1000 ? "border-left" : "sl-no"} text-center align-middle`}><span className="spanTopBar" style={{ color: "#000000" }}>{ind + 1}</span></td>
                                                        <td rowspan="2" className={`${window.innerWidth < 1000 ? "" : "tr-title pl-2"} align-middle spanTopBar`}>
                                                            {this.state.isView ?
                                                                <span className="spanTopBar pl-2" style={{ color: "#000000" }}>{i.TrainingTitle && i.TrainingTitle}</span> :
                                                                ((this.state.findtrtitle == true && i.TrainingTitle.trim() == "" && this.state.Training_View[this.state.Training_View.length - 1].Id == i.Id) || (i.TrainingTitle.trim() == "" && this.state.Training_View[this.state.Training_View.length - 1].Id != i.Id)) ? <>
                                                                    <CssTextFieldLast
                                                                        multiline
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        type="text"
                                                                        id={"title" + i.Id}
                                                                        autoFocus={this.state.index == i.Id ? true : false}
                                                                        onChange={(e) => this.handleInputChange(e, i.Id)}
                                                                        onBlur={(e) => this.handleClick(e, i.Id)}
                                                                        onFocus={(e) => this.handleFocusNameChange(e, i, 'Name')}
                                                                        value={i.TrainingTitle && i.TrainingTitle}
                                                                        InputProps={{
                                                                            className: `border-radius padding-space spanTopBar ${classes.inputfieldAlign}`
                                                                        }}
                                                                    />
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Training Title is required</span>
                                                                </>
                                                                    :
                                                                    <CssTextField
                                                                        multiline
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        type="text"
                                                                        autoFocus={this.state.index == i.Id ? true : false}
                                                                        id={"title" + i.Id}
                                                                        onChange={(e) => this.handleInputChange(e, i.Id)}
                                                                        onBlur={(e) => this.handleClick(e, i.Id)}
                                                                        onFocus={(e) => this.handleFocusNameChange(e, i, 'Name')}
                                                                        value={i.TrainingTitle && i.TrainingTitle}
                                                                        InputProps={{
                                                                            className: `border-radius padding-space spanTopBar ${classes.inputfieldAlign}`
                                                                        }}
                                                                    />
                                                            }
                                                        </td>
                                                        <td height='40px' className={`${window.innerWidth < 1000 ? "" : "pldate-aldate"} align-middle plan-color `}><span className="spanTopBar">Planned Date</span></td>
                                                        {this.state.Training_Month && this.state.Training_Month.map((m) => (<>
                                                            {
                                                                i.ActualDate && i.ActualDate.map((a, index) => (<>
                                                                    {a.Month == m.Month ?
                                                                        <td className="text-center align-middle tableview-set plan-color" onMouseEnter={() => this.setState({ HoverId: a.Id })} onMouseLeave={() => this.setState({ HoverId: 0 })}>
                                                                            {i.TrainingTitle.trim() == "" ? <></> :
                                                                                this.state.isView ?
                                                                                    <span className="spanTopBar" style={{ color: "#000000" }}>{a.PlannedDate && moment(a.PlannedDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</span> :
                                                                                    <> {(a.PlannedDate == "" || a.PlannedDate == null && a.Id == this.state.HoverId) ?
                                                                                        <input className="cursorPointer" type="date" placeholder="" max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                                                        min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")} onChange={(e) => { this.handleChangeDate(e, a) }} id="session-date" name="session-date"></input>
                                                                                        : <input type="date" max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                                                        min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")} className="cursorPointer" placeholder={a.PlannedDate && moment(a.PlannedDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")} onChange={(e) => { this.handleChangeDate(e, a) }} id="session-date1" name="session-date"></input>
                                                                                    }</>}
                                                                        </td> : ""}
                                                                </>))
                                                            }
                                                        </>))}
                                                        {this.state.isView === false ? <>
                                                            <td rowspan="2" className={`${window.innerWidth < 1000 ? "border-right" : "action"} border-right text-center tableview-set align-middle`}><button disabled={(this.state.isView || (this.state.Training_View[this.state.Training_View.length - 1].Id == i.Id && i.TrainingTitle.trim() == "")) ? true : false} onClick={() => { this.OpenPopup(i.Id) }} className={`${classes.button}`} ><img src={Delete} style={{ opacity: (this.state.isView || (this.state.Training_View[this.state.Training_View.length - 1].Id == i.Id && i.TrainingTitle.trim() == "")) ? '0.5' : '' }}></img></button></td>
                                                        </> : <></>}
                                                    </tr>
                                                    <tr>
                                                        <td height='40px' className={`${window.innerWidth < 1000 ? "" : "pldate-aldate"} align-middle actual-color`}><span className="spanTopBar" style={{ color: "#000000" }}>Actual Date</span></td>
                                                        {this.state.Training_Month && this.state.Training_Month.map((m) => (<>
                                                            {i.ActualDate && i.ActualDate.map((a, index) => (<>
                                                                {a.Month == m.Month ?
                                                                    <td className="text-center align-middle tableview-set spanTopBar actual-color" onMouseEnter={() => this.setState({ actualHoverId: a.Id })} onMouseLeave={() => this.setState({ actualHoverId: 0 })}>
                                                                        {(i.TrainingTitle.trim() == "") ? <></> :
                                                                            (a.ActualDate == null && Date.parse(moment(a.PlannedDate).format("YYYY-MM-DD")) <= Date.parse(moment(new Date()).format("YYYY-MM-DD"))) ? <button className={classes.UnButton} onClick={() => { this.ActualEditPage(a.Id) }}>-</button> :
                                                                                (a.ActualDate != null) ? <button className={`${classes.linkButton} f-size-13`} onClick={() => { this.ActualEditPage(a.Id) }}>{a.ActualDate && moment(a.ActualDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</button> :
                                                                                    (a.PlannedDate != null && a.Id == this.state.actualHoverId) ?
                                                                                        <button className={`${classes.whiteButton} mt-2 f-size-13`} onClick={() => { this.ActualEditPage(a.Id) }}>{a.ActualDate && moment(a.ActualDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</button> : <></>
                                                                        }
                                                                    </td> : ""}
                                                            </>))}
                                                        </>))}
                                                    </tr>
                                                </>)) : <></>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {this.state.isView ? <></> :
                                <div className="col-12 text-end pt-3 mb-5">
                                    <button className={classes.button} onClick={() => this.AddNew()}><i className="fa fa-plus pr-2" style={{ color: "#00838F" }}></i>Add</button>
                                </div>}
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5></div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => { window.$("#deletepopup").modal("hide") }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        settings: state.commonReducer.settings || [],
    };
}

ListViewTPOY.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ListViewTPOY))
);
